module.exports = __webpack_public_path__ + "static/media/19.b5e5a8a5.jpg";